<h3-selectable-object [objectIndex]="responseObject.index" [padding]="8">
  <div class="column-container">
    <div *ngIf="(isCollapsed$ | async) === false" class="column">
      <div class="header subtitle-03">
        <div class="compare-tools">
          @if (canSelectLatestVersion) {
            <mat-button-toggle-group
              [value]="selectedVersion$ | async"
              (valueChange)="selectedVersion$.next($event)"
            >
              <mat-button-toggle value="Original"
                ><span class="subtitle-03">Original</span></mat-button-toggle
              >
              <mat-button-toggle value="Latest"
                ><span class="subtitle-03">Latest</span></mat-button-toggle
              >
            </mat-button-toggle-group>
          } @else {
            <div class="version-label subtitle-02">Original</div>
          }

          <mat-slide-toggle
            labelPosition="before"
            [checked]="isCompareEnabled$ | async"
            (change)="isCompareEnabled$.next($event.checked)"
          >
            <span class="subtitle-03">Compare</span>
          </mat-slide-toggle>
        </div>

        <div class="horizontal-divider"></div>
      </div>
      @let referenceText = referenceText$ | async;
      @if (referenceText !== undefined) {
        @if (isCompareEnabled$ | async) {
          <div class="diff-container">
            @for (diffPart of diff$ | async; track diffPart) {
              <span
                class="body-01"
                [ngClass]="{
                  added: diffPart.added,
                  removed: diffPart.removed,
                }"
                >{{ diffPart.value }}</span
              >
            }
          </div>
        } @else if (!isReadOnly && (selectedVersion$ | async) === 'Latest') {
          <h3-highlight-response
            [objectIndex]="responseObject.index"
            [text]="referenceText"
          ></h3-highlight-response>
        } @else {
          <span class="reference-text">{{ referenceText }}</span>
        }
      } @else {
        <sama-skeleton-loader></sama-skeleton-loader>
        <sama-skeleton-loader></sama-skeleton-loader>
        <sama-skeleton-loader></sama-skeleton-loader>
      }
    </div>

    <div class="collapse-left">
      <div class="vertical-divider"></div>
      <button mat-icon-button color="primary" (click)="toggleCollapse()">
        <mat-icon
          class="material-symbols-outlined"
          [class.flip-icon]="isCollapsed$ | async"
        >
          chevron_left
        </mat-icon>
      </button>
      <div class="vertical-divider"></div>
    </div>

    <div class="column editor-container">
      <div class="header subtitle-03">
        <div class="editor-header">
          <div class="version-label subtitle-02">Current</div>
          <span class="rewritten-chip">
            {{ percentageOfChange$ | async | percent: '1.0-1' }}
            change from
            {{ selectedVersion$ | async }}
          </span>
        </div>

        <div class="horizontal-divider"></div>
      </div>

      @let editorText = editorText$ | async;
      @if (!isReadOnly) {
        <textarea
          class="text body-01"
          [value]="editorText"
          (input)="updateText($event)"
          (focusin)="setUpPushCurrentStateSubscription()"
          (focusout)="textAreaFocusOut$.next()"
        ></textarea>
      } @else if ((isSampling$ | async) === true) {
        <h3-highlight-response
          [objectIndex]="responseObject.index"
          [text]="editorText"
          [editable]="(hasSampFinalized$ | async) === false"
          [deletable]="true"
        ></h3-highlight-response>
      } @else {
        <span class="text body-01"> {{ editorText }} </span>
      }
    </div>
  </div>
</h3-selectable-object>
